import { HandCoins } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import { Button } from '~/components/component-library'
import { IAddress } from '~/types'

type RequestButtonProps = {
  defaultAccount?: IAddress
  isDisabled?: boolean
  disabledReason?: string
} & (
  | { asChild: true; children: React.ReactNode }
  | { asChild?: false; children?: never }
)

// Requesting funds means creating an invoice; `account` preselects where the
// funds land.
const buildRequestPath = (defaultAccount?: IAddress) => {
  const params = new URLSearchParams()
  if (defaultAccount) {
    params.set('account', defaultAccount)
  }
  const queryString = params.toString()
  return `/invoices/create${queryString ? `?${queryString}` : ''}`
}

export const RequestButton = (props: RequestButtonProps) => (
  <SplitsLink path={buildRequestPath(props.defaultAccount)}>
    {props.asChild ? (
      props.children
    ) : (
      <Button
        variant="secondary"
        prefix={<HandCoins />}
        isDisabled={props.isDisabled}
        disabledReason={props.disabledReason}
      >
        Request
      </Button>
    )}
  </SplitsLink>
)
